import { Node } from '@tiptap/core';
import { ReactNodeViewRenderer, NodeViewWrapper, NodeViewContent } from '@tiptap/react';
import type { NoteType } from '@ifixit/wiki-components/wiki-note';
import '@ifixit/wiki-components/wiki-note';

declare module '@tiptap/core' {
   interface Commands<ReturnType> {
      note: {
         toggleNote: (noteType: NoteType) => ReturnType;
         setNoteType: (noteType: NoteType) => ReturnType;
      };
   }
}

export const Note = Node.create<never, never>({
   name: 'note',
   content: 'block*',
   group: 'block',
   renderHTML({ HTMLAttributes }) {
      return ['wiki-note', HTMLAttributes, 0];
   },
   addNodeView() {
      return ReactNodeViewRenderer(Component);
   },
   addAttributes() {
      return {
         type: {
            default: null,
            renderHTML: attributes => ({
               type: attributes.type.trim(),
            }),
         },
      };
   },
   addCommands() {
      return {
         toggleNote:
            (noteType: NoteType) =>
            ({ chain }) =>
               chain().toggleWrap(this.name).updateAttributes(this.name, { type: noteType }).run(),
         setNoteType:
            (noteType: NoteType) =>
            ({ chain }) =>
               chain().updateAttributes(this.name, { type: noteType }).run(),
      };
   },
});

const Component = (props: { node: { attrs: { type: NoteType | null } } }) => (
   <NodeViewWrapper>
      <wiki-note type={props.node.attrs.type}>
         <NodeViewContent />
      </wiki-note>
   </NodeViewWrapper>
);
